export { InfoRow } from './InfoRow';
